import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Info, Shield, LifeBuoy, FileText, Sparkles } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation('translation');
  return (
    <footer className="w-full bg-brand-dark/80 backdrop-blur-md border-t border-white/5 py-12 px-6 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-10">
          <div className="flex flex-col items-center md:items-start gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-500 rounded-xl flex items-center justify-center font-bold text-white text-sm shadow-xl shadow-purple-500/20">V</div>
              <span className="font-bold text-2xl text-white tracking-tighter">{t('common.brand_name')}</span>
            </div>
            <p className="text-gray-500 text-sm font-medium max-w-xs text-center md:text-left">
              {t('footer.tagline')}
            </p>
            <p className="text-gray-600 text-xs mt-2">&copy; {new Date().getFullYear()} {t('footer.rights')} • v1.0.0</p>
          </div>

          <nav className="flex flex-wrap justify-center gap-x-12 gap-y-6">
            <div className="flex flex-col gap-4">
              <h4 className="text-white font-bold text-sm uppercase tracking-widest">{t('footer.navigation')}</h4>
              <Link to="/dashboard" className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-medium">
                <LayoutDashboard className="w-4 h-4 text-purple-400 group-hover:scale-110 transition-transform" />
                {t('footer.credits_spending')}
              </Link>
              <Link to="/about" className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-medium">
                <Info className="w-4 h-4 text-blue-400 group-hover:scale-110 transition-transform" />
                {t('footer.about_us')}
              </Link>
              <Link to="/welcome" className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-medium">
                <Sparkles className="w-4 h-4 text-yellow-400 group-hover:scale-110 transition-transform" />
                {t('footer.how_to_pin')}
              </Link>
            </div>

            <div className="flex flex-col gap-4">
              <h4 className="text-white font-bold text-sm uppercase tracking-widest">{t('footer.legal')}</h4>
              <Link to="/privacy" className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-medium">
                <Shield className="w-4 h-4 text-green-400 group-hover:scale-110 transition-transform" />
                {t('footer.privacy')}
              </Link>
              <Link to="/tos" className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-medium">
                <FileText className="w-4 h-4 text-blue-400 group-hover:scale-110 transition-transform" />
                {t('footer.terms')}
              </Link>
              <a href="mailto:songokumbl@gmail.com" className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-medium">
                <LifeBuoy className="w-4 h-4 text-orange-400 group-hover:scale-110 transition-transform" />
                {t('footer.support')}
              </a>
            </div>
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center">
          <p className="text-gray-600 text-xs">
            {t('footer.made_with')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
